export default __webpack_public_path__ + "static/media/shop_7.65074c79.gif";